/**
 * Shared Document (DocumentReference) FHIR extension URLs.
 *
 * Canonical source of truth for both web and mobile — avoids URL drift
 * between apps/web/models/files/Document.ts and mobile helpers.
 */

export const DocumentExtension = {
  ParsingStatus: "vibrant.document.parsing-status",
  ParserSessionId: "vibrant.document.parser-session-id",
  ExpectedParserTypes: "vibrant.document.expected-parser-types",
  CompletedParserTypes: "vibrant.document.completed-parser-types",
  FailedParserTypes: "vibrant.document.failed-parser-types",
  ParserOutcomeSummary: "vibrant.document.parser-outcome-summary",
  ParsingFailureReason: "vibrant.document.parsing-failure-reason",
  /** Why a `held` lab document is held. Absent while it only waits for the check. */
  ParsingHoldReason: "vibrant.document.parsing-hold-reason",
  EffectiveDate: "vibrant.document.effective-date",
  EffectiveDateSource: "vibrant.document.effective-date-source",
  Source: "vibrant.document.source",
  ClassificationTypes: "vibrant.document.classification-types",
  ManualCategoryCode: "vibrant.document.manual-category-code",
  /**
   * Immutable instant the record was created, stamped once at create. Distinct from
   * `meta.lastUpdated` (per-version, moves on every edit) and from `DocumentReference.date`
   * (a semantic/clinical date a caller may supply). Exists so a creation timestamp published
   * to an external contract stays stable for the life of the record.
   */
  CreatedAt: "vibrant.document.created-at",
} as const;

export const ParserOutcomePolicyVersion = 1 as const;

export const ParserTrackingDocumentExtensionUrls = [
  DocumentExtension.ParsingStatus,
  DocumentExtension.ParserSessionId,
  DocumentExtension.ExpectedParserTypes,
  DocumentExtension.CompletedParserTypes,
  DocumentExtension.FailedParserTypes,
  DocumentExtension.ParserOutcomeSummary,
  DocumentExtension.ParsingFailureReason,
  DocumentExtension.ParsingHoldReason,
] as const;
